module.exports = __webpack_public_path__ + "static/media/IBM-Technical-Support-Certfication.a1ab5c0d.png";